<div [ngClass]="{'text-left': left == true,'text-center': left != true}">
  <h2 *ngIf="data.title" class="text-base font-semibold leading-7 wild-accent-colour">{{data.title}}</h2>
  <p *ngIf="data.subtitle" class="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{{data.subtitle}}</p>
  <p *ngIf="data.paragraph" class="mt-6 text-lg leading-8 text-gray-600">{{data.paragraph}}</p>
</div>
